<template>
  <div class="flex flex-col gap-y-3">
    <NText variant="caption1" weight="medium">
      <i18n-t
        scope="global"
        keypath="option.strategyConfirmDialogMessage"
        tag="div"
      >
        <template #position>
          <NText variant="caption1" weight="medium">
            {{ position }}
          </NText>
        </template>

        <template #strategyRegistration>
          <NText variant="caption1" weight="bold">
            {{ t('option.strategyRegistration') }}
          </NText>
        </template>

        <template #marginSource>
          <NText variant="caption1" weight="bold">
            {{ marginSource }}
          </NText>
        </template>
      </i18n-t>
    </NText>

    <div class="flex gap-x-3">
      <NButton class="w-full" size="small" @click="handleConfirmOrder">
        {{ t('common.yes') }}
      </NButton>

      <NButton class="w-full" size="small" color="gray" @click="remove()">
        {{ t('common.refuse') }}
      </NButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog } from '@negar/core';

const emit = defineEmits(['confirmOrder']);

defineProps({
  position: {
    type: String,
    required: true,
  },
  marginSource: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();

const { remove } = useDialog();

const handleConfirmOrder = () => {
  emit('confirmOrder');

  remove();
};
</script>
